import {getCurrentYear} from '../../utils/commons'
import BestGardenPicksLogo from './logo'
import {bestGardenPicksStyles} from './styles'

const baseConfig = {
  domainName: 'bestgardenpicks' as const,
  domainType: 'picks' as const,
  camelCaseUrl: 'BestGardenPicks.com',
  siteName: 'Best Garden Picks',
  logo: <BestGardenPicksLogo className="size-9 shrink-0 tablet:size-6" />,
  favicon: '/favicons/bestgardenpicks.png',
  styles: bestGardenPicksStyles,
}

const localeConfigs = {
  us: {
    measurementId: 'G-13FHYWNWBG',
    title: (category: string, _count: string) =>
      `${getCurrentYear()}’s Best ${category} - Reviews You Can Trust | BestGardenPicks.com`,
    description: (_category?: string, _count?: string) =>
      `At BestGardenPicks.com, we research, compare, and share authentic reviews to make buying the right gardening products and tools easy. Discover the top-rated products your lawn will love.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
